/* TOKOWAKA：商品卡片「滑鼠移動切換商品照」（只在有滑鼠的裝置啟用）
   - 照片寬度平均分給每張照片，滑鼠在哪一段就顯示哪一張。
   - 交叉淡化：新照片放到最上層淡入，下面那張保持不動，淡入完成後才收起下面的照片，
     所以不會透出底色。淡入途中換下一張，會直接疊上新的一張繼續淡入（可以打斷）。
   - 第 1 張用主圖的複本當作一格，切回第 1 張時同樣是淡化；滑鼠離開、淡化完成後收起全部，
     露出原本的主圖。
   - 系統設定「減少動態效果」時直接換圖。
   - 說明文件：Shopify/outputs/card-fade-2026-10-23/README.md */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var FADE_MS = 220; // 與 tokowaka.css 的 transition 一致
  var HYSTERESIS = 0.12; // 交界處的緩衝（一格寬度的比例），避免在交界來回跳
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var current = null;
  var states = new WeakMap();

  function stateOf(scrub) {
    var st = states.get(scrub);
    if (!st) {
      st = { index: 0, stack: [], z: 1, timer: 0, frames: null, hovering: false };
      states.set(scrub, st);
    }
    return st;
  }

  // 第一次移進商品卡就把其他照片放進頁面並開始下載
  function load(scrub) {
    var st = stateOf(scrub);
    if (st.frames) return st;
    var bar = scrub.querySelector('.tk-scrub__bar');
    var tpl = scrub.querySelector('template');
    if (tpl) scrub.insertBefore(tpl.content.cloneNode(true), bar);

    var base = scrub.parentElement.querySelector('.media > img');
    if (base) {
      var first = base.cloneNode(false);
      first.removeAttribute('id');
      first.setAttribute('alt', '');
      first.className = 'tk-scrub__img';
      scrub.insertBefore(first, scrub.firstChild);
    }

    var imgs = scrub.querySelectorAll('.tk-scrub__img');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].removeAttribute('loading');
      imgs[i].decoding = 'async';
    }
    st.frames = imgs;
    return st;
  }

  function hide(img) {
    img.classList.add('is-instant');
    img.classList.remove('is-shown');
  }

  function isLoaded(img) {
    return img.complete && img.naturalWidth > 0;
  }

  // 最上層那張淡入完成後：收起下面的照片；滑鼠已離開且回到第 1 張時，全部收起露出主圖
  function settle(scrub) {
    var st = stateOf(scrub);
    clearTimeout(st.timer);
    var top = st.stack[st.stack.length - 1];
    if (top && !isLoaded(top)) {
      top.addEventListener('load', function () { settle(scrub); }, { once: true });
      return;
    }
    st.timer = setTimeout(function () {
      var keep = st.hovering || st.index !== 0 ? 1 : 0;
      while (st.stack.length > keep) hide(st.stack.shift());
    }, reduceMotion.matches ? 0 : FADE_MS + 40);
  }

  function show(scrub, index) {
    var st = stateOf(scrub);
    var segs = scrub.querySelectorAll('.tk-scrub__seg');
    for (var j = 0; j < segs.length; j++) segs[j].classList.toggle('is-active', j === index);
    if (st.index === index) return;
    st.index = index;

    var target = st.frames && st.frames[index];
    if (!target) return;
    clearTimeout(st.timer);
    var stack = st.stack;
    var top = stack[stack.length - 1];

    if (stack.length >= 2 && stack[stack.length - 2] === target) {
      // 回到正下方那張：把最上層淡出即可
      top.classList.remove('is-instant');
      top.classList.remove('is-shown');
      stack.pop();
    } else if (target !== top) {
      var at = stack.indexOf(target);
      if (at !== -1) {
        stack.splice(at, 1);
        hide(target);
        void target.offsetWidth; // 先回到透明，再淡入
      }
      target.classList.remove('is-instant');
      target.style.zIndex = ++st.z;
      target.classList.add('is-shown');
      stack.push(target);
    }
    settle(scrub);
  }

  function enter(scrub) {
    var st = load(scrub);
    if (st.hovering) return;
    st.hovering = true;
    scrub.classList.add('is-hovering');
  }

  function leave(scrub) {
    var st = stateOf(scrub);
    if (!st.hovering) return;
    st.hovering = false;
    scrub.classList.remove('is-hovering');
    show(scrub, 0);
    settle(scrub);
  }

  function pick(st, ratio, frames) {
    var pos = ratio * frames;
    var cur = st.index;
    if (pos >= cur - HYSTERESIS && pos < cur + 1 + HYSTERESIS) return cur;
    return Math.max(0, Math.min(frames - 1, Math.floor(pos)));
  }

  document.addEventListener(
    'pointermove',
    function (event) {
      if (event.pointerType !== 'mouse') return;
      var card = event.target.closest && event.target.closest('.card-wrapper');
      var scrub = card && card.querySelector('[data-tk-scrub]');
      if (current && current !== scrub) leave(current);
      current = scrub || null;
      if (!scrub) return;

      load(scrub);
      var rect = scrub.parentElement.getBoundingClientRect();
      var inside =
        event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside || rect.width === 0) {
        leave(scrub);
        return;
      }

      enter(scrub);
      var frames = parseInt(scrub.dataset.frames, 10) || 1;
      show(scrub, pick(stateOf(scrub), (event.clientX - rect.left) / rect.width, frames));
    },
    { passive: true }
  );

  document.documentElement.addEventListener('pointerleave', function () {
    if (current) leave(current);
    current = null;
  });
})();
